const timeoutSpan = 60 * 1000;
export function loadScript(src, scriptContainer) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.charset = 'utf-8';
        let timeout;
        const cleanup = function cleanup() {
            script.onerror = null;
            script.onload = null;
            clearTimeout(timeout);
        };
        const onComplete = function onComplete() {
            cleanup();
            resolve();
        };
        const onError = function onError(e) {
            cleanup();
            const errorType = e && (e.type === 'load' ? 'missing' : e.type);
            const error = new Error(`Loading script error: ${errorType}, src: ${src}`);
            reject(error);
        };
        // Wait for resource loading, then timeout
        timeout = setTimeout(() => {
            onError({ type: 'timeout' });
        }, timeoutSpan);
        script.onload = onComplete;
        script.onerror = onError;
        scriptContainer.appendChild(script);
    });
}
//# sourceMappingURL=loadScript.js.map